import React from 'react';
import { Menu, Bell, User } from 'lucide-react';

const Header = ({ toggleSidebar }) => {
  const username = localStorage.getItem('username') || 'Unknown User';
  const role = localStorage.getItem('role') || 'Role';

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 md:px-6 sticky top-0 z-10">
      <div className="flex items-center">
        <button 
          onClick={toggleSidebar}
          className="md:hidden text-slate-500 hover:text-slate-700 mr-4"
        >
          <Menu className="w-6 h-6" />
        </button>
        <h2 className="text-xl font-semibold text-slate-800 hidden sm:block">
          Overview
        </h2>
      </div>

      <div className="flex items-center gap-4">
        <button className="text-slate-400 hover:text-primary-600 relative transition-colors">
          <Bell className="w-5 h-5" />
          <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full border border-white"></span>
        </button>
        
        <div className="h-8 w-px bg-slate-200 mx-2"></div>
        
        <div className="flex items-center gap-3 cursor-pointer">
          <div className="flex flex-col items-end hidden md:flex">
            <span className="text-sm font-medium text-slate-900">{username}</span>
            <span className="text-xs text-slate-500 capitalize">{role}</span>
          </div>
          <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 border border-slate-200">
            <User className="w-5 h-5" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
